// 🟢 PRODUCTION SERVER URL
const PRODUCTION_URL = 'https://college.ssquareg.tech';

// 🟡 LOCAL DEVELOPMENT URL
const LOCAL_URL = 'http://localhost:9980';

// 🎯 ACTIVE API BASE URL (Active: PRODUCTION)
export const API_BASE_URL = PRODUCTION_URL;
// export const API_BASE_URL = LOCAL_URL;


